import { Anchor, AnchorProps, Button, ButtonProps } from "@mantine/core"
import { Link, LinkOptions, RegisteredRouter } from "@tanstack/react-router"

export const LinkAnchor = <TTo extends string = ".">(
  props: LinkOptions<RegisteredRouter, "/", TTo> &
    AnchorProps &
    React.PropsWithChildren
) => {
  return <Anchor component={Link} {...(props as any)} />
}

export const LinkButton = <TTo extends string = ".">(
  props: LinkOptions<RegisteredRouter, "/", TTo> & ButtonProps
) => {
  return <Button component={Link} {...(props as any)} />
}
